import { Breadcrumbs } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export interface IBreadcrumbItems {
  label: string;
  link: string;
}

export interface IBreadcrumbProps {
  items?: IBreadcrumbItems[];
}

const initialItems = [{ label: "Home", link: "/" }];

export function Breadcrumb({ items = initialItems }: IBreadcrumbProps) {
  const location = useLocation();

  const [breadcrumbItems, setBreadcrumbItems] =
    useState<IBreadcrumbItems[]>(items);

  const buildBreadcrumb = useCallback(() => {
    const pathname = location.pathname.split("/");
    const arr: IBreadcrumbItems[] = [];

    function renderLink(
      isLast: boolean,
      current: string,
      prev?: IBreadcrumbItems,
    ) {
      if (isLast) return "";
      if (prev) return `${prev.link}/${current}`;
      return "/";
    }

    for (let i = 0; i < pathname.length; i += 1) {
      const current: string = pathname[i];
      const prev: IBreadcrumbItems | undefined = arr.length
        ? arr[arr.length - (i - 1)]
        : undefined;
      const isLast: boolean = i + 1 === pathname.length;

      if (current) {
        arr.push({
          label: current.replace("-", " "),
          link: renderLink(isLast, current, prev),
        });
      }
    }

    if (arr.length) {
      setBreadcrumbItems((prevState) => [...prevState, ...arr]);
    }
  }, [location.pathname]);

  useEffect(() => {
    buildBreadcrumb();
  }, [buildBreadcrumb]);

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2.5 }}>
      {breadcrumbItems.map((item: IBreadcrumbItems) => {
        if (item.link) {
          return (
            <Link
              key={`breadcrumb#${item.label}`}
              to={item.link}
              className="no-underline hover:underline font-dmsans text-xs text-secondary inline-flex capitalize"
            >
              {item.label}
            </Link>
          );
        }

        return (
          <strong
            key={`breadcrumb#${item.label}`}
            className="text-primary text-xs font-dmsans font-semibold capitalize"
          >
            {item.label}
          </strong>
        );
      })}
    </Breadcrumbs>
  );
}
